<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense color="secondary" elevation="1" rounded>
                    <v-breadcrumbs class="ms-n6" :items="[
                        {text: 'Warehouse & Inventory'},
                        {text: 'Warehouse'},
                        {text: 'Modify Warehouse Item'}
                    ]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Modify Warehouse Item
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon @click="handleRemove" v-if="hasPermission(perm.warehouse_item.delete)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                            <v-btn depressed color="primary" @click="handleSave">
                                <v-icon>mdi-content-save</v-icon>
                                save
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-progress-linear indeterminate v-if="loading"/>
                    <div class="pa-3">
                        <WarehouseItemForm ref="form" v-model="data" v-if="!warehouseLoading && !itemLoading && !fetchLoading"/>
                        <WarehouseItemLoader v-else/>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import WarehouseItemForm from './../../components/warehouse/WarehouseItemForm';
import WarehouseItemLoader from './../../components/warehouse/WarehouseItemLoader';
import PAlert from './../../components/common/PAlert';

export default {
    name: "WarehouseItemEditView",
    components: {
        WarehouseItemForm,
        WarehouseItemLoader,
        PAlert
    },
    data() {
        return {
            warehouseId: null,
            itemId: null,
            loading: false,
            data: null,
            warehouseLoading: false,
            itemLoading: false,
            fetchLoading: false,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            warehouseFindByID: "warehouse/warehouse/findByID",
            pushWarehouse: "warehouse/warehouse/search/push",
            itemFindByID: "stock/item/findByID",
            pushItem: "stock/item/search/push",
            snackbar: "ui/snackbar/show",
            update: "stock/warehouseItem/update",
            remove: "stock/warehouseItem/remove",
            findByID: "stock/warehouseItem/findByID"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.saveAsnyc};
        },
        saveAsnyc() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.update(this.data).then(() => {
                this.$router.push({name: "WarehouseItemList", query: { warehouseId: this.data.warehouse_id }})
                this.snackbar({ text: "Warehouse Item Updated", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        handleRemove() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to ditach this item from warehouse?", callback: this.removeAsync};
        },
        removeAsync() {
            this.loading = true;
            this.remove(this.data).then(() => {
                this.$router.push({name: "WarehouseDisplay", params: { id: this.warehouseId }})
                this.snackbar({ text: "Item has been detached from the warehouse", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        fetchWarehouseAsync() {
            this.warehouseLoading = true;
            this.warehouseFindByID(this.warehouseId).then(response => {
                this.data.warehouse_id = response.data.id;
                this.pushWarehouse(response.data);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.warehouseLoading = false
            })
        },
        fetchItemAsync() {
            this.itemLoading = true;
            this.itemFindByID(this.itemId).then(response => {
                this.data.item_id = response.data.id;
                this.pushItem(response.data);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.itemLoading = false
            })
        },
        fetchWarehouseItemAsync() {
            this.fetchLoading = true;
            this.findByID({itemId: this.itemId, warehouseId: this.warehouseId}).then(response => {
                this.data = {...this.data, ...response.data};
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.fetchLoading = false
            })
        }
    },
    mounted() {
        this.warehouseId = this.$route.params.warehouseId;
        this.itemId = this.$route.params.itemId;
        this.data = {};
        this.fetchWarehouseAsync();
        this.fetchItemAsync();
        this.fetchWarehouseItemAsync();
    }
}
</script>

<style>

</style>